import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { geySalesOrdersFarmer, getBatchSalesOrders, getBatchOrders, getOrdersById } from "../../../../services/orders"
import { IconButton, Tooltip, Typography } from "@mui/material"
import Table from "../../../../components/table"
import Layout from "../../../../components/layout"
import Modal from '@mui/material/Modal';
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button } from "@mui/material"
import FileUploadIcon from '@mui/icons-material/FileUpload';
import moment from "moment"
import PrintIcon from '@mui/icons-material/Print';
import QRCode from "react-qr-code";

const config = require('../../../../config')
const ROOT = config.ROOT
const HistoryDetail = () => {

    const { order_id } = useParams()
    const [order_list, setOrderList] = useState(true)
    const [order_detail, setOrderDetail] = useState(true)
    const [row_detail, setRowDetail] = useState(true)
    let token = localStorage.getItem('accessToken')
    let role_id = localStorage.getItem('role_id')
    let user_id = localStorage.getItem('user_id')

    const [show_qrcode, setShowQrCode] = useState(false)
    const printRef = useRef();
    const [batch_detail, setBatchDetail] = useState(null)

    let navigate = useNavigate()

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getBatchSalesOrders({ order_id, role_id }, token);
                const res_order = await getOrdersById(order_id, token);
                setOrderDetail(res_order.data.data)
                const data = res.data.data;
                const promises = data.map(item =>
                    geySalesOrdersFarmer({ user_id, order_id: item.from_order_id }, token)
                        .then(res => {
                            if (res.status === 200) {
                                return res.data.data[0];
                            }
                            return null; // ถ้า status ไม่ใช่ 200 จะ return null
                        })
                        .catch(error => {
                            console.error(error);
                            if (error.response?.status === 403) {
                                navigate('/login');
                            }
                            return null; // กรณี error ให้ return null
                        })
                );
                const results = await Promise.all(promises);
                const list = data.map((item, index) => {
                    const farmerData = results[index]; // ข้อมูลที่ได้จาก geySalesOrdersFarmer
                    if (!farmerData) return null; // ข้ามถ้า null

                    return {
                        id: farmerData.id,
                        batch_id: farmerData.batch_id,
                        orders_no: farmerData.orders_no,
                        orderer: farmerData.user.firstname + ' ' + farmerData.user.lastname,
                        order_date: moment(farmerData.create_date).format('DD MMM YYYY'),
                        delivery_date: farmerData.delivery_date
                            ? moment(farmerData.delivery_date).format('DD MMM YYYY')
                            : '',
                        product: farmerData.product.name + ' ' + farmerData.attribute[0].value,
                        status: farmerData.status_desc,
                        quantity: item.quantity,
                        img_slip: farmerData.img_slip,
                        confirm_payment: farmerData.confirm_payment,
                        tag_user_id: farmerData.user.tag_user_id,

                        batch_id: item.batch_id,
                    };
                }).filter(item => item !== null);

                setOrderList(list);
            } catch (error) {
                console.error("Error fetching batch sales orders", error);
            }
        };

        fetchData();
    }, [order_id, role_id, token, user_id, navigate]);




    const columns = [
        { field: 'orders_no', headerName: 'เลขคำสั่งซื้อ', width: 150, align: 'center' },
        { field: 'orderer', headerName: 'เกษตรกร', width: 250, align: 'center' },
        { field: 'order_date', headerName: 'วันที่สั่ง', width: 200, align: 'center' },
        { field: 'status', headerName: 'สถานะ', width: 100, align: 'center' },
        {
            field: 'product', headerName: 'สินค้า / SKU', width: 550, align: 'center',
            renderCell: (params) => (
                <Tooltip title={params.value} arrow>
                    <Typography noWrap>{params.value}</Typography>
                </Tooltip>
            )
        },
        {
            field: 'quantity',
            headerName: 'น้ำหนัก (kgs)',
            width: 150,
            align: 'center',
            headerAlign: 'center',
            valueFormatter: (params) => {
                const value = Number(params.value);
                return isNaN(value)
                    ? ''
                    : value.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    });
            },
        },
        { field: 'delivery_date', headerName: 'วันที่ส่งมอบ', width: 200, align: 'center' },

    ]
    if (role_id === '2') {
        columns.push(
            {
                field: "check",
                headerName: "Print QR Code",
                width: 200,
                align: 'center',
                renderCell: (params) => (
                    <Tooltip title={<Typography>Print QR Code</Typography>} >
                        <IconButton color="primary" onClick={() => showQrcode(params.row)}>
                            <PrintIcon sx={{ color: '#15322D', fontSize: 40 }} />
                        </IconButton>
                    </Tooltip>
                ),
            });
    }
    const style_assign = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const handlePrint = () => {
        const printContents = printRef.current.innerHTML;
        const printWindow = window.open("", "", "width=800,height=600");
        printWindow.document.write(`
                <html>
                <head>
                    <style>
                        @page {
                            size: 100mm 150mm;
                            margin: 0;
                        }
                        body {
                            margin: 0;
                            font-family: 'Arial', sans-serif;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 100%;
                        }
                        .print-area {
                            width: 100mm;
                            height: 150mm;
                            padding: 10mm;
                            box-sizing: border-box;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: flex-start;
                            text-align: left;
                        }
                        .qr {
                            margin-bottom: 12px;
                        }
                        b {
                            font-weight: bold;
                        }
                        p {
                            margin: 2px 0;
                            font-size: 14px;
                        }
                    </style>
                </head>
                <body>
                    <div class="print-area">
                        ${printContents}
                    </div>
                </body>
                </html>
            `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };
    const showQrcode = async (row) => {

        setRowDetail(row)
        let res_batch = await getBatchOrders({ order_id: order_id, role_id: role_id }, token)

        console.log("batch_detail", res_batch.data.data[0])
        console.log("row",row)

        setBatchDetail(res_batch.data.data[0])
        setShowQrCode(true)
    }
    return (
        <Layout title='รายการเกษตรกร'>
            <Modal
                open={show_qrcode}
                onClose={() => setShowQrCode(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ zIndex: 2 }}
            >
                <Box sx={style_assign}>
                    <IconButton
                        style={{ position: "absolute", top: 8, right: 8 }}
                        onClick={() => setShowQrCode(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                    {/* QR Code */}
                    <Box ref={printRef}>
                        <Box display="flex" justifyContent="center" mb={2}>
                            <QRCode value={ROOT + "/substance/record/" + row_detail?.batch_id + "_" + order_id} size={128} />
                        </Box>
                        {/* รายละเอียด */}
                        <Typography><b>Lot No. :</b> {order_detail?.lot_no}</Typography>
                        <Typography><b>ID FARMER :</b></Typography>
                        {batch_detail?.farmers?.length > 0 ? (
                            <Typography>
                                {row_detail?.tag_user_id} = {Number(row_detail?.quantity || 0).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })} kgs
                            </Typography>
                        ) : (
                            <Typography>No farmer data available</Typography>
                        )}
                        <Typography><b>วันที่-เวลาเข้า:</b> {row_detail.delivery_date}</Typography>
                    </Box>

                    {/* ปุ่มพิมพ์ */}
                    <Box display="flex" justifyContent="center" mt={3}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#f2f2f2",
                                color: "#000",
                                fontWeight: "bold",
                                borderRadius: "12px",
                                px: 4,
                            }}
                            onClick={handlePrint}
                        >
                            Print QR CODE
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Table
                rows={order_list}
                columns={columns}
            />
        </Layout>
    )
}

export default HistoryDetail